// File: src/graphql/registryQueries.ts

export const GET_REGISTRIES = `
  query GetRegistries {
    getRegistries {
      id
      category
      is_header
      code
      code_type
      ordering
      createdAt
      modifiedAt
      status
      translations {
        id
        language_id
        code_value
        comment
        mark
        is_active
        editor_id
        createdAt
        modifiedAt
        status
      }
    }
  }
`

export const GET_CATEGORIES = `
query GetRegistryCategories {
  getRegistryCategories {
    id
    category
    is_header
    code
    code_type
    ordering
    createdAt
    modifiedAt
    status
    translations {
      id
      language_id
      code_value
      comment
      mark
      is_active
      editor_id
      createdAt
      modifiedAt
      status
    }
  }
}
`

export const GET_CATEGORY_ITEMS = `
query GetRegistryCategory( $categoryId: Int! ) {
  getRegistryCategory( categoryId: $categoryId ) {
    id
    category
    is_header
    code
    code_type
    ordering
    createdAt
    modifiedAt
    status
    translations {
      id
      language_id
      code_value
      comment
      mark
      is_active
      editor_id
      createdAt
      modifiedAt
      status
    }
  }
}
`

export const GET_REGISTRIES_B = `
  query GetRegistries(
    $offset: Int!
    $limit: Int!
    $filters: JSON
    $ordering: String
  ) {
    getAllRegistries(offset: $offset, limit: $limit, filters: $filters, ordering: $ordering) {
      registries {
        id
        is_header
        category
        ordering
        code
        code_type
        createdAt
        modifiedAt
        status
      }
      totalCount
    }
  }
`

export const GET_REGISTRY_TRANSLATIONS = `
  query GetRegistryTranslations($registry_id: Int!) {
    getRegistryTranslations(registry_id: $registry_id) {
      id
      registry_id
      language_id
      is_active
      editor_id
      code_value
      comment
      createdAt
      modifiedAt
      mark
      status
    }
  }
`

export const MARK_REGISTRY_TRANSLATIONS = `
  mutation MarkRegistryTranslation($trans_id: Int!) {
    markRegistryTranslation(trans_id: $trans_id)
  }
`

// export const CREATE_REGISTRY = `
//   mutation CreateRegistry($input: CreateRegistryInput!) {
//     createRegistry(input: $input) {
//       id
//       is_header
//       category
//       ordering
//       code
//       code_type
//       createdAt
//       modifiedAt
//       status
//     }
//   }
// `

export const UPDATE_REGISTRY = `
mutation UpdateRegistry($input: UpdateRegistryInput!) {
  updateRegistry(input: $input) {
      id
      category
      code
      code_type
      ordering
      createdAt
      modifiedAt
      status
      translations {
        id
        language_id
        code_value
        comment
        mark
        is_active
        editor_id
        createdAt
        modifiedAt
        status
      }
    }
}
`

/* example of union output case
export const UPDATE_REGISTRY = `
mutation UpdateRegistry($input: UpdateRegistryInput!) {
  updateRegistry(input: $input) {
    __typename
    ... on IntResult {
      value
    }
    ... on Registry {
      id
      category
      code
      code_type
      ordering
      createdAt
      modifiedAt
      status
      translations {
        id
        language_id
        code_value
        comment
        mark
        is_active
        editor_id
        createdAt
        modifiedAt
        status
      }
    }
    ... on RegistryTranslation {
      id
      registry_id
      language_id
      is_active
      editor_id
      code_value
      comment
      createdAt
      modifiedAt
      mark
      status
    }
  }
}
`
*/

// export const UPDATE_REGISTRY = `
//   mutation UpdateRegistry($id: ID!, $input: UpdateRegistryInput!) {
//     updateRegistry(id: $id, input: $input) {
//       id
//       is_header
//       category
//       ordering
//       code
//       code_type
//       createdAt
//       modifiedAt
//       status
//     }
//   }
// `

export const DELETE_REGISTRY = `
  mutation DeleteRegistry($id: Int!) {
    deleteRegistry(id: $id)
  }
`

export const DELETE_CATEGORY = `
  mutation DeleteCategory($category: Int!) {
    deleteCategory(category: $category)
}
`

// You might also want to add a query for fetching a single registry if needed
export const GET_REGISTRY = `
  query GetRegistry($id: Int!) {
    getRegistry(id: $id) {
      id
      is_header
      category
      ordering
      code
      code_type
      createdAt
      modifiedAt
      status
    }
  }
`

//
export const ACTIVATE_REGISTRY_TRANSLATION = `
  mutation ActivateRegistryTranslation($trans_id: Int!) {
    activateRegistryTranslation(trans_id: $trans_id)
  }
`

//
export const UPDATE_REGISTRY_ITEM_STATUS = `
mutation UpdateRegistryItemStatus($trans_id: Int!, $status: Int!) {
  updateRegistryItemStatus(trans_id: $trans_id, status: $status)
  }
`

//
//
export const DELETE_REGISTRY_TRANSLATION = `
mutation DeleteRegistryTranslation($trans_id: Int!) {
  deleteRegistryTranslation(trans_id: $trans_id)
}
`
